import { CountUp } from 'countup.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

gsap.registerPlugin(ScrollTrigger)


if (document.querySelector('.countup__number')){

gsap.utils.toArray('.countup__number').forEach(countupContainer => {
  let counter = countupContainer.querySelector(".countup__number__count")
  if(!counter) return
  let tlCounter = gsap.timeline();

  gsap.fromTo(countupContainer, {
    autoAlpha: 0,
    y: 100,
  },{
    scrollTrigger: {
      once: true,
      trigger: countupContainer,
      start: "top 100%",
      end: "bottom center",
    },
    autoAlpha: 1,
    y: 0,
  })

  gsap.to(counter, {
    scrollTrigger: {
      trigger: counter,
      onEnter: countUpStart,
      once: true,
      start: "top 100%",
      end: "bottom center",
    },
    duration: 1,
  });


  function countUpStart() {
    var counter_value = counter.innerHTML;
    let counter_format = 0;
    let counter_duration = 1;
    // let counter_value = [];

    // counter_value.push(parseValues(counter.innerHTML))
    // counter.innerHTML = '0'



    let options = {
      useEasing: true,
      useGrouping: true,
      decimalPlaces: 0,
      startVal: 0,
      separator: ',',
      decimal: '.',
      prefix: '',
      suffix: '',
      enableScrollSpy: true,
      scrollSpyOnce: true,
    }

    // Anzahl der Dezimalstellen
    if(!isInt(counter_value)) {
      options.decimalPlaces = 2
    }


    // Formatierung der Zahlen nach Sprache
    if (document.documentElement.lang == 'de') {
      options.separator = '.'
      options.decimal = ','
    }


    var cu = new CountUp(counter, counter_value, options)
    cu.start();
    }

  });

  function parseValues(val) {
    if (isInt(val)) {
      val = parseInt(val)
    } else {
      val = parseFloat(val.replace(',','.'))
    }
    return val
  }


  function isInt(val) {
    return val % 1 === 0
  }

}
